<div class="pagination-group" *ngIf="p.pages.length > 1">
    <ul class="pagination">
        <li [class.disabled]="p.isFirstPage()" (click)="p.previous()">
            <a href="javascript:void(0)" tabindex="-1">
              <i class="icon icon-arrow-left"></i>
            </a>
        </li>
        <li *ngFor="let page of p.pages" [class.active]="p.getCurrent() === page.value" (click)="p.setCurrent(page.value)">
            <a href="javascript:void(0)"  *ngIf="p.getCurrent() !== page.value">{{ page.label }}</a>
            <a href="javascript:void(0)" *ngIf="p.getCurrent() === page.value" >{{ page.label }}</a>
        </li>
        <li (click)="p.next()" *ngIf="!p.isLastPage()">
            <a href="javascript:void(0)">
              <i class="icon icon-arrow-right"></i>
            </a>
        </li>
        <li [class.disabled]="p.isLastPage()" *ngIf="p.isLastPage()">
            <a href="javascript:void(0)">
              <i class="icon icon-arrow-right"></i>
            </a>
        </li>
    </ul>
</div> 